const logError = (error: any) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(error)
  } else {
    // TODO: add production error tracking
  }
}

export default logError
